import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { color } from '../../../app/theme';
import Switch from '../../shared/Switch';
import TextEditor from '../../shared/TextEditor';
import RowTitle from '../RowTitle';

const useStyles = makeStyles(
  {
    root: {
      marginBottom: 36,
    },
    inputBlock: {
      borderRadius: 24,
      padding: '12px 16px',
      backgroundColor: color.$19,
      display: 'inline-block',
    },
    tip: {
      fontSize: '13px',
      fontStyle: 'normal',
      fontWeight: '400',
      lineHeight: 'normal',
      color: color.$11,
      marginBottom: 12,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
  },
  {
    name: 'EndDetection',
  },
);

const EndDetection = ({
  isChecked,
  onSwitchChange,
  value,
  onChange,
  isSaved,
  disabled,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { pathKey } = useSelector(store => store.aiBot);

  return (
    <div className={classes.root}>
      <RowTitle
        title={t(`${pathKey}:endDetection`)}
        tooltip={t(`${pathKey}:endDetectionTooltip`)}
      />
      <div className={classes.inputBlock}>
        <div className={classes.tip}>
          {t(`${pathKey}:endDetectionSubtitle`)}
          <Switch
            style={{ marginLeft: 4 }}
            onChange={onSwitchChange}
            checked={isChecked}
            disabled={disabled}
          />
        </div>
        <TextEditor
          onChange={onChange}
          origriData={value}
          placeholder={t(`${pathKey}:endDetectionPlaceholder`)}
          style={{ width: 601 }}
          isError={isSaved && !value}
          disabled={disabled}
        />
      </div>
    </div>
  );
};

export default EndDetection;
